import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { ContentSearchStore } from '../../domain/stores/createContentSearchStore';
import { SearchResults } from './SearchResults';
import { SearchShimmer } from './SearchShimmer';
import { Css, H6, Responsive } from '../../../../ui';
import { Color } from '../../../../styles/Color';

interface IInformationSearchListProps {
	store: ContentSearchStore;
	isDebouncing: boolean;
}

export const InformationSearchList = observer(
	({ store, isDebouncing }: IInformationSearchListProps) => {
		const { loading, content, error, pagination } = store;

		const onLoadMore = () => {
			store.bumpOffset();
		};

		const showLoading = loading || isDebouncing;
		const informationCount = showLoading ? '' : `(${pagination.nbHits})`;

		if (error && !showLoading) return null; // error state
		if (content.length === 0 && !showLoading) return null; // empty state

		return (
			<div>
				<ListTitle>Information {informationCount}</ListTitle>
				{showLoading ? (
					<SearchShimmer />
				) : (
					<SearchResults
						results={content}
						pagination={pagination}
						onLoadMore={onLoadMore}
					/>
				)}
			</div>
		);
	},
);

const ListTitle = styled(H6)`
	margin-bottom: ${Css.pxToRem(12)};
	color: ${Color.PrimaryBlue};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(16)};
	}
`;
